import { defineComponent as _defineComponent } from 'vue';
import { RouterLink } from "vue-router";
import {} from "@/components/Common/index";
import localize from "@/utils/localization";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BreadcrumbHeading',
    props: {
        items: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, RouterLink, localize, Heading };
    }
});
